module.exports = __webpack_public_path__ + "static/spoon-ec6b60ecc06f34bd174459276fd8c3a0.png";